import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from 'classnames';
import { dataType } from '@/constants/data-type';

import '../../../assets/styles/components/detail-center/warrants.scss' 
import filter from '@/companys/fubon/assets/images/icons/market-filter.png'
import filterActive from '@/companys/fubon/assets/images/icons/market-filter-active.png'

import { getSafe } from '@/helpers/global'; 
import LoadingLayer from '@/components/Spinner/LoadingLayer'; 
import SearchIcon from '@/assets/images/icons/nav_icon_search.png';
import DataTable from '@/components/DataTable/DataTable';
import { utilsFunction, Converter, Comparator,keyDownFunctions,accessibilityFunctions } from "@/helpers/functions";
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY,LOADING_TYPE } from "@/constants/app";
import { stockActions } from "@/actions/trading/stock.action";

import RadioOptions from '@/components/TabHeader/RadioOptions';



class Summary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            columnDefs:[
                {
                  headerName: props.language.common_symbol,
                  colId: 'common_symbol',
                  field: 'symbol',
                  headerClass: 'table-header',
                  cellClass: 'table-cell cursor',
                  dataType: dataType.SYMBOL,
                  minWidth: 100,
                  onCellClicked:(e)=>this.handleCellClick(e)
                },
                {
                  headerName: props.language.common_name,
                  colId: 'common_name',
                  field: 'stockName',
                  headerClass: 'table-header',
                  cellClass: 'table-cell',
                  dataType: dataType.TEXT,
                  minWidth:260
                },
                {
                  headerName: props.language.common_price,
                  colId: 'common_price',
                  field: 'price',
                  headerClass: 'table-header text-end',
                  cellClass: 'table-cell',
                  dataType: dataType.CURRENCY,
                  comparator: Comparator.numberComparator,
                  minWidth: 67,
                },
                {
                  headerName: props.language.common_change,
                  colId: 'market_change',
                  field: 'change',
                  headerClass: 'table-header text-end',
                  cellClass: 'table-cell text-end',
                  bindingColor: true,
                  dataType: dataType.CURRENCY,
                  comparator: Comparator.numberComparator,
                  minWidth:142
                },
                {
                    headerName: props.language.common_turnover,
                    colId: 'common_turnover',
                    field: 'turnover',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.CASH,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_strike,
                    colId: 'market_warrants_strike',
                    field: 'strike',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.CURRENCY,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_call_level,
                    colId: 'market_warrants_call_level',
                    field: 'callLevel',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.CURRENCY,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_implied_volatility,
                    colId: 'market_warrants_implied_volatility',
                    field: 'impvol',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.CURRENCY,
                    comparator: Comparator.numberComparator,
                    minWidth:140
                },
                {
                    headerName: props.language.market_warrants_premium,
                    colId: 'market_warrants_premium',
                    field: 'premium',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.PERCENT_BASED,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_leverage_ratio,
                    colId: 'market_warrants_leverage_ratio',
                    field: 'leveratio',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.PERCENT_BASED,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_strike_ratio,
                    colId: 'market_warrants_strike_ratio',
                    field: 'strikeratio',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.PERCENT_BASED,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_last_trading_day,
                    colId: 'market_warrants_last_trading_day',
                    field: 'ltd',
                    headerClass: 'table-header text-center',
                    cellClass: 'table-cell text-center',
                    dataType: dataType.SHORT_DATE,
                    comparator: Comparator.numberComparator,
                },
                {
                    headerName: props.language.common_good_till_date,
                    colId: 'common_good_till_date',
                    field: 'gtd',
                    headerClass: 'table-header text-center',
                    cellClass: 'table-cell text-center',
                    dataType: dataType.SHORT_DATE,
                    comparator: Comparator.numberComparator
                },
                {
                    headerName: props.language.market_warrants_remaining_trading_day,
                    colId: 'market_warrants_remaining_trading_day',
                    field: 'rtd',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.PERCENT_BASED,
                    comparator: Comparator.numberComparator,
                    minWidth:170
                },
                {
                    headerName: props.language.market_warrants_outstanding_quantity,
                    colId: 'market_warrants_outstanding_quantity',
                    field: 'otq',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.CURRENCY,
                    comparator: Comparator.numberComparator,
                    minWidth:140
                },
                {
                    headerName: props.language.market_warrants_outstanding_ratio,
                    colId: 'market_warrants_outstanding_ratio',
                    field: 'otr',
                    headerClass: 'table-header text-end',
                    cellClass: 'table-cell text-end',
                    dataType: dataType.PERCENT_BASED,
                    comparator: Comparator.numberComparator,
                    minWidth:140
                },


              ], 
            selectTab:[
                {id:1,value:'common_all' , isActive:true},
                {id:2,value:'market_call', isActive:false},
                {id:3,value:'market_put', isActive:false},
                {id:4,value:'market_bull', isActive:false},
                {id:5,value:'market_Bear', isActive:false},
                {id:6,value:'market_inline_warrants', isActive:false},
            ],
            selectTabIndex:1,
            warrantsdata:null,
            last:"",
            rowData : null,
            filterDatalist:[
                {title:'common_all',bool:true},
                {title:'market_sg',bool:true,issuer:'SG'},
                {title:'market_bp',bool:true,issuer:'BP'},
                {title:'market_cs',bool:true,issuer:'CS'},
                {title:'market_cc',bool:true,issuer:'CC'},
                {title:'market_ea',bool:true,issuer:'EA'},
                {title:'market_gs',bool:true,issuer:'GS'},
                {title:'market_hs',bool:true,issuer:'HS'},
                {title:'market_jp',bool:true,issuer:'JP'},
                {title:'market_mb',bool:true,issuer:'MB'},
                {title:'market_sc',bool:true,issuer:'SC'},
                {title:'market_ub',bool:true,issuer:'UB'},
                {title:'market_bi',bool:true,issuer:'BI'},
                {title:'market_db',bool:true,issuer:'DB'},
                {title:'market_dw',bool:true,issuer:'DW'},
                {title:'market_ml',bool:true,issuer:'ML'},
                {title:'market_nm',bool:true,issuer:'NM'},
                {title:'market_rb',bool:true,issuer:'RB'},
                {title:'market_ra',bool:true,issuer:'RA'},
                {title:'market_bc',bool:true,issuer:'BC'},
                {title:'market_ht',bool:true,issuer:'HT'},
                {title:'market_vt',bool:true,issuer:'VT'},
                {title:'market_ms',bool:true,issuer:'MS'},
                {title:'market_gj',bool:true,issuer:'GJ'},
            ],
            Radiogroup:[
                {label:'common_all',value:'all'},
                {label:'market_3_months',value:'<3Months'},
                {label:'market_3_6_months',value:'3_6Months'},
                {label:'market_6_12_months',value:'6_12Months'},
                {label:'market_12_months',value:'>12Months'},
            ],
            showFilterBlock:false,
            currentRadio:'all',
            filterData:'',
            load:true
        }
    }
    render() {
        const { language, autoSize } = this.props;
        const { selectTab,columnDefs,warrantsdata,filterDatalist,Radiogroup,showFilterBlock,load} = this.state
        return (
                <div className='warrants' >
                    <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
                    <div className='filter_block' onClick={(e) => this.StopTheEvent(e)}  style={{display : showFilterBlock ? 'block' :'none'}} >
                        <div className='filter_block_content' >
                            <h4>{language.market_publisher}</h4>
                            <div className='publisher' >
                            {  filterDatalist.map((item,index)=>{
                                return (  <div key={index} className='publisher_item'>
                                    <input  type='checkbox' id={item.title} checked={item.bool}  onChange={() => this.handlePublisherItemClick(index)} ></input>
                                    <label for={item.title}>{language[item.title]}</label>
                                </div> )
                            })}
                            </div>
                            <h4>{language.market_maturity}</h4>
                            <div className='maturity' >
                                <RadioOptions options={Radiogroup} onChange={(opt) => this.handleSelectRadioType(opt)} ></RadioOptions>
                            </div>
                        </div>
                    </div>
                    <div className='block_select'>
                        <div className='left-func'>
                            {
                                selectTab.map((item,index)=>
                                    <div key={item.id} className={classnames('select-tab' , item.isActive && 'active-tab')} onClick={()=>this.changeSelect(index,item)}
                                         onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.changeSelect(index,item))}
                                         {...accessibilityFunctions.hasTabIndex()}>{language[item.value]}</div>
                                )
                            }
                        </div>
                        <div className='right-func'>
                            <div className='search-func'>
                                <span className='target'>{language.market_warrants_search_target}</span>
                                <img src={SearchIcon} alt='search_icon'  onClick ={this.SummaryFiltering}/>
                                <input
                                    id='text'
                                    type="text"
                                    autocomplete="off"
                                    ref={e => this.warrantInputRef = e}
                                    onBlur={this.SummaryFiltering}
                                    onKeyDown={this.handleInputKeyDown}
                                />
                                <div className='search-btn' onClick ={this.SummaryFiltering} onKeyDown={keyDownFunctions.handleEnterKeyDown(this.SummaryFiltering)}{...accessibilityFunctions.hasTabIndex()}>
                                    {language.common_search}
                                </div>
                            </div>
                            <div className='filter-btn' onClick={(e) => this.handleFilterClick(e)}
                                 onKeyDown={keyDownFunctions.handleEnterKeyDown((e) => this.handleFilterClick(e))}
                                 {...accessibilityFunctions.hasTabIndex()}>
                                <img src={showFilterBlock ? filterActive : filter} />
                                <span style={{color:showFilterBlock ? '#1296db' : ''}} >{language.market_warrants_filter}</span>
                            </div>
                        </div>
                    </div>
                    <div className='warrants-table' key={warrantsdata}>
                    <DataTable
                        showPagination={false}
                        columnDefs={columnDefs}
                        innerRef={e => this.tableRef = e}
                        data={warrantsdata} 
                        />
                    </div>
                </div>
        )
    }

    componentDidMount() {
        this.props.innerRef(this)
            this.getWarrants()
        document.addEventListener('click',this.hiddenFilterBlock)
    }
    componentDidUpdate(preProps) {
        const { language , marketParams } = this.props
        if (language && preProps.language !== language) {
                this.getWarrants()
		}
        if (marketParams && preProps.marketParams !== marketParams) {
            if((Number(marketParams.stockCode)<=10000 || Number(marketParams.stockCode) >= 29999) ){
                this.getWarrants()
            }
        }
    }

    componentWillUnmount(){
        document.removeEventListener('click',this.hiddenFilterBlock)
    }
    handleCellClick = (e) =>{
        const marketID =  Converter.mappingMDSMarketToStock(e.value.split('.')[0])
        const stockCode = e.value.split('.')[1] 
        if((stockCode >= 10000 && stockCode <= 29999)){
            if(!this.props.NCmarketParams?.NCstockCode){
                    this.props.setNCstock({NCstockCode:this.props.marketParams.stockCode,NCmarketID:this.props.marketParams.marketID},()=>{
                })
            }
        }
        
        this.props.setStock({stockCode,marketID},()=>{})
    }
    StopTheEvent = (e) =>{
        e.stopPropagation()
    }

    SummaryFiltering = () =>{
        const {selectTab,rowData,filterDatalist,currentRadio} = this.state
        let filterData = rowData
        if(!rowData) return
        let selectTabId = selectTab.filter((item)=>{
          return   item.isActive == true
        })
        switch(selectTabId[0].id){
            case 2:
                filterData = rowData.filter(e=>e.type==='DW' && e.subType==='Bullish')
                break;
            case 3:
                filterData = rowData.filter(e=>e.type==='DW' && e.subType==='Bearish')
                break;
            case 4:
                filterData = rowData.filter(e=>e.type==='CBBC' && e.subType==='Bullish')
                break;
            case 5:
                filterData = rowData.filter(e=>e.type==='CBBC' && e.subType==='Bearish')
                break;
            case 6:
                filterData = rowData.filter(e=>e.type==='InlineWarrant')
                break;
            default:
                filterData = rowData
                break;
        }
        filterData = filterData.filter(e=>e.symbol.split('.')[1].indexOf(this.warrantInputRef.value) !== -1 )
        let showData = []
        let publisherFilterData = filterDatalist.filter((item)=>{
            return item.bool == true
        }) 
        let Arr = []
        if(publisherFilterData != []){
             publisherFilterData.forEach((PItem)=>{
            Arr.push(PItem.issuer)
        })
        filterData.forEach((FItem)=>{
            if(Arr.includes(FItem.issuer)){
                showData.push(FItem)
            }
        })
        filterData = showData
        } else filterData = []
        const nowTime = new Date().getTime()
        switch(currentRadio){
            case 'all':
                this.setState({warrantsdata:filterData});
                break;
            case '<3Months':
                filterData = filterData.filter(item => {
                    return   item.gtd - nowTime  < 7776000000
                })
                this.setState({warrantsdata:filterData});
                break;
            case '3_6Months':
                filterData =  filterData.filter((item,index)=>{
                    return item.gtd - nowTime < 15552000000 && item.gtd - nowTime > 7776000000
                })
                this.setState({warrantsdata:filterData});
                break;
            case '6_12Months':
                filterData = filterData.filter((item,index)=>{
                    return item.gtd - nowTime < 31536000000 && item.gtd - nowTime > 15552000000
                })
                this.setState({warrantsdata:filterData});
                break;
            case '>12Months':
                filterData = filterData.filter((item,index)=>{
                    return   item.gtd - nowTime > 31536000000
                })
                this.setState({warrantsdata:filterData});
                break;
        }
    }

    hiddenFilterBlock = () =>{
        this.setState({showFilterBlock:false})
    }
    handleSelectRadioType = (opt) =>{
        switch(opt.value){
            case 'all':
                this.setState({currentRadio:'all'},()=>this.SummaryFiltering())
                break;
            case "<3Months":
                this.setState({currentRadio:'<3Months'},()=>this.SummaryFiltering())
            break;
            case '3_6Months':
                this.setState({currentRadio:'3_6Months'},()=>this.SummaryFiltering())
                break;
            case '6_12Months':
                this.setState({currentRadio:'6_12Months'},()=>this.SummaryFiltering())
                break;
            case '>12Months':
                this.setState({currentRadio:'>12Months'},()=>this.SummaryFiltering())
                break;
        }
    }

    handlePublisherItemClick = (index) =>{
        let {filterDatalist} = this.state
        if(index == 0){
            if(filterDatalist[0].bool == true){
                filterDatalist.forEach(item =>{
                    item.bool = false
                })
                this.setState({filterDatalist},()=>{
                    document.querySelector('input[id="common_all"]').indeterminate = false
                    this.SummaryFiltering()
                })
            } else {
                filterDatalist.forEach(item =>{
                    item.bool = true
                })
                this.setState({filterDatalist},()=>{
                    document.querySelector('input[id="common_all"]').indeterminate = false
                    this.SummaryFiltering()
                })
            }
        }
        else {
            filterDatalist[index].bool = !filterDatalist[index].bool
            let temp = []
            filterDatalist.forEach((item,index)=>{
                if(index == 0) return
                else {temp.push(item.bool)}
            })
            if(temp.includes(false)) {
                filterDatalist[0].bool = false
                this.setState({filterDatalist},()=>{
                    document.querySelector('input[id="common_all"]').indeterminate = true
                    this.SummaryFiltering()
                })
            } else {
                filterDatalist[0].bool = true
                this.setState({filterDatalist},()=>{
                    document.querySelector('input[id="common_all"]').indeterminate = false
                    this.SummaryFiltering()
                })
            }
        }
    }

    handleFilterClick = (e) =>{
        e.stopPropagation()
        this.setState({showFilterBlock:!this.state.showFilterBlock})
    }

    resetData = () =>{
        let selectTab =[
            {id:1,value:'common_all' , isActive:true},
            {id:2,value:'market_call', isActive:false},
            {id:3,value:'market_put', isActive:false},
            {id:4,value:'market_bull', isActive:false},
            {id:5,value:'market_Bear', isActive:false},
            {id:6,value:'market_inline_warrants', isActive:false},
        ]
        let filterDatalist = [
            {title:'common_all',bool:true},
            {title:'market_sg',bool:true,issuer:'SG'},
            {title:'market_bp',bool:true,issuer:'BP'},
            {title:'market_cs',bool:true,issuer:'CS'},
            {title:'market_cc',bool:true,issuer:'CC'},
            {title:'market_ea',bool:true,issuer:'EA'},
            {title:'market_gs',bool:true,issuer:'GS'},
            {title:'market_hs',bool:true,issuer:'HS'},
            {title:'market_jp',bool:true,issuer:'JP'},
            {title:'market_mb',bool:true,issuer:'MB'},
            {title:'market_sc',bool:true,issuer:'SC'},
            {title:'market_ub',bool:true,issuer:'UB'},
            {title:'market_bi',bool:true,issuer:'BI'},
            {title:'market_db',bool:true,issuer:'DB'},
            {title:'market_dw',bool:true,issuer:'DW'},
            {title:'market_ml',bool:true,issuer:'ML'},
            {title:'market_nm',bool:true,issuer:'NM'},
            {title:'market_rb',bool:true,issuer:'RB'},
            {title:'market_ra',bool:true,issuer:'RA'},
            {title:'market_bc',bool:true,issuer:'BC'},
            {title:'market_ht',bool:true,issuer:'HT'},
            {title:'market_vt',bool:true,issuer:'VT'},
            {title:'market_ms',bool:true,issuer:'MS'},
            {title:'market_gj',bool:true,issuer:'GJ'},
        ]
        let currentRadio = 'all'
        this.warrantInputRef.value = ''
        this.setState({selectTab,filterDatalist,currentRadio})
    }

    getWarrants=()=>{
        let marketID = null
        let stockCode = null
        if(this.props.marketParams.stockCode <= 10000 || this.props.marketParams.stockCode >= 29999){
            if(!this.props.marketParams.marketID || !this.props.marketParams.stockCode){ 
                this.tableRef.toggleLoadingOverlay(false);
                this.setState({load:false,warrantsdata:[]})
                return
            }
            marketID = this.props.marketParams.marketID
            stockCode = this.props.marketParams.stockCode
        }else {
            if(!this.props.NCmarketParams.NCmarketID || !this.props.NCmarketParams.NCstockCode){ 
                this.tableRef.toggleLoadingOverlay(false);
                this.setState({load:false,warrantsdata:[]})
                return
            }
            marketID = this.props.NCmarketParams.NCmarketID
            stockCode = this.props.NCmarketParams.NCstockCode
        }
        this.props.getQuote({exchangeID:marketID,instrumentID:stockCode},res =>{
            if(res.rtnCode){
                this.tableRef.toggleLoadingOverlay(false);
                this.setState({load:false,warrantsdata:[]})
                return
            }
            this.setState({last:res.last},()=>{
        this.setState({rowData:null,load:true})
        this.tableRef.toggleLoadingOverlay(false);
        const { last } = this.state
        const { language } = this.props
        let stockID = ''
        if(stockCode){
            stockID = stockCode.split('').findIndex(i => i !== '0')
            if (stockID > -1) stockID = stockCode.substr(stockID)
            const params ={
                symbol: { exchangeID: Converter.mappingWebSocketMarket(marketID), key: stockID },
            }
            this.props.getWarrants(params,warrants=>{
                if(warrants.rtnCode){
                    this.tableRef.toggleLoadingOverlay(false);
                    this.setState({load:false,warrantsdata:[]})
                }
                if (warrants.warrantBullBearRecord?.data){
                    let warrantslist = []
                    for(let i=0;i<warrants.warrantBullBearRecord.data.length;i++){
                        let warrantlist = {
                            exchangeID : warrants.warrantBullBearRecord.data[i][0],
                            code : warrants.warrantBullBearRecord.data[i][1],
                            type : warrants.warrantBullBearRecord.data[i][2],
                            subType : warrants.warrantBullBearRecord.data[i][3],
                            name : warrants.warrantBullBearRecord.data[i][4],
                            tcName : warrants.warrantBullBearRecord.data[i][5],
                            scName : warrants.warrantBullBearRecord.data[i][6],
                            issuer : warrants.warrantBullBearRecord.data[i][7],
                            tcIssuer : warrants.warrantBullBearRecord.data[i][8],
                            scIssuer : warrants.warrantBullBearRecord.data[i][9],
                            expDate : warrants.warrantBullBearRecord.data[i][10],
                        }
                        if(warrantlist.issuer){
                            warrantslist.push(warrantlist)
                        }
                    }
                    const lang = this.props.language.lang
                    const sample = ['symbol', 'stockName', 'price', 'change',
                    'turnover' , 'strike' , 'callLevel', 'impvol', 'premium', 'leveratio',
                    'strikeratio', 'ltd',  'gtd' ,'rtd','otq', 'otr', 'type', 'subType', 'issuer','tcIssuer','scIssuer', 'expDate'].reduce((prev, next) => (prev[next] = '-', prev), {})
                    const rowData = []
                    for(let j=0;j<warrantslist.length;j++){
                        const item = warrantslist[j]
                        const deepSample = JSON.parse(JSON.stringify(sample))
                        deepSample.symbol = [item.exchangeID, item.code].join('.')
                        deepSample.type = item.type
                        deepSample.subType = item.subType
                        deepSample.issuer = item.issuer
                        deepSample.tcIssuer = item.tcIssuer
                        deepSample.scIssuer = item.scIssuer
                        deepSample.expDate = item.expDate
                         if (lang === 'zh_TW') {
                            deepSample.stockName = item.tcName
                          } else if (lang === 'zh_CN') {
                            deepSample.stockName = item.scName
                          } else {
                            deepSample.stockName = item.name
                          }
                          const dparams = {
                            symbols: [
                              {
                                exchangeID: item.exchangeID,
                                key: item.code
                              }
                            ],
                            sessID:this.props.mdsToken
                          }
                          this.props.getDetailPriceInfo(dparams,(quetores)=>{
                            if(quetores){
                              let remainingDate = null
                              const twoNewRowData = JSON.parse(JSON.stringify(this.state.warrantsdata));
                              const deepSample = twoNewRowData[j]
                              const date = new Date().getTime()
                              const lastDate = (quetores.derivative.lastDate - date) / (1000*3600*24)
                              if(JSON.stringify(lastDate).split('.')[0] < 1 && JSON.stringify(lastDate).split('.')[0] > 0){
                                remainingDate = language.market_warrants_less_than_a_day                          
                              }else if(JSON.stringify(lastDate).split('.')[0] > 1){
                                remainingDate = JSON.stringify(lastDate).split('.')[0]
                              }else{
                                remainingDate =  language.common_expired
                              }
                              deepSample.price = quetores.last;
                              deepSample.change = `${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)}`
                              deepSample.turnover = quetores.turnover
                              deepSample.strike = quetores.derivative.strike;
                              deepSample.callLevel = quetores.derivative.call;
                              deepSample.impvol = quetores.derivative.amplitudeExp;
                              if(deepSample.type === 'DW' && deepSample.subType === 'Bullish'){
                                deepSample.premium = utilsFunction.datatableFormatPercent([((quetores.derivative.strike-0) + quetores.last * quetores.derivative.entitleRatio )-(last-0)] / (last-0) * 100)
                              }else if(deepSample.type === 'DW' && deepSample.subType === 'Bearish'){
                                deepSample.premium = utilsFunction.datatableFormatPercent(((last-0)-[(quetores.derivative.strike-0) - quetores.last * quetores.derivative.entitleRatio] / (last-0) * 100))
                              }
                              if(quetores.derivative.leverRatio){
                                deepSample.leveratio = (quetores.derivative.leverRatio-0).toFixed(2)
                              }
                              if(quetores.derivative.leverRatio){
                                deepSample.strikeratio = (quetores.derivative.entitleRatio-0).toFixed(2)
                              }
                              deepSample.ltd = quetores.derivative.lastDate;
                              deepSample.gtd =  quetores.derivative.expDate;
                              deepSample.rtd = remainingDate
                              deepSample.otq = quetores.derivative.streetVol;
                              deepSample.otr = utilsFunction.formatPercent(quetores.derivative.streetRatio);
                              this.setState({warrantsdata:twoNewRowData,rowData:twoNewRowData,filterData:twoNewRowData})
                                }
                            })
                            rowData.push(deepSample);
                    }
                    
                    this.setState({warrantsdata:rowData,rowData:rowData ,filterData:rowData,load:false},()=>{this.resetData()})
                }else {
                    this.setState({warrantsdata:[],load:false})
                }
            })
        }else {
            this.setState({warrantsdata:[],load:false})
        }
            })
        })
    }

    changeSelect=(index)=>{
        const { selectTab } = this.state
        this.warrantInputRef.value=''
        for(let i=0;i<selectTab.length;i++){
            selectTab[i].isActive = false
        }
        selectTab[index].isActive =true
        this.setState({selectTab},()=>{ this.SummaryFiltering()})
    }

    handleInputKeyDown=(event)=>{
        if (event.key === 'Enter') {
            this.warrantInputRef.blur()
          }
    }
}
Summary.defaultProps = {
    autoSize: true,
    quoteData:''
}

export default connect(
    state => ({
        language: state.app.language,
        marketParams: state.trade.marketParams,
        NCmarketParams:state.trade.NCmarketParams,
        mdsToken: state.trade.mdsToken,
    }),
    dispatch => ({
        getWarrants: (p, c) => stockActions.getwarrantsAction(p,c),
        // getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)), // MDS LV2
        getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
        setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
        setNCstock:(p,res)=> dispatch(stockActions.setNoChangeMarketStockAction(p,res)),
        getDetailPriceInfo: (p, c) => dispatch(stockActions.getWarrantDetailPriceInfoAction(p, c)),
    })
)(Summary)